import React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const NoMatchPage = () => {

    React.useEffect(() => {

    }, []);

    return (
        <div
            className="d-flex"
        >
            <div>
                <h2>Nothing to see here!</h2>
                <p>
                    <Link to="/">Go to the home page</Link>
                </p>
                <Button>Click</Button>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/about">About</Link>
                    </li>
                    <li>
                        <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li>
                        <Link to="/nothing-here">Nothing Here</Link>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default NoMatchPage;
